import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useScope } from '@/contexts/ScopeContext';
import { GlobalBanner } from '@/components/notifications';

export function LiveModeBanner() {
  const { mode, organization, portfolio } = useScope();

  if (mode?.name !== 'Live') {
    return null;
  }

  return (
    <GlobalBanner
      tone="critical"
      icon={<AlertTriangle className="h-4 w-4" />}
      title="Live Trading"
      description={`${organization?.name ?? 'Tenant'} / ${portfolio?.name ?? 'Portfolio'}`}
    />
  );
}
